import { useSubscriptionContext } from "@/hooks/use-subscription";
import { PlansType } from "@/lib/models/plan";
import { useTranslations } from "next-intl";
import { useRouter } from "next/navigation";
import SectionPageLayout from "../layouts/section-page-layout";
import PricingTable from "../pricing-table";

const Pricing = () => {
      const t = useTranslations('pricing_table');
      const { setPlanInterested } = useSubscriptionContext();
      const router = useRouter();


      const onSubscribe = (plansType: PlansType) => {
            setPlanInterested(plansType);
            router.push('/auth/signin');
      }

      return (
            <SectionPageLayout id="pricing" sectionClassName="bg-gray-50 dark:bg-gray-900">
                  <div className="section-container text-center">
                        <h2 className="text-3xl md:text-4xl font-bold text-balance">
                              {t('pricing_that_scales_with_your_needs')}
                        </h2>
                        <p className="text-lg text-gray-600 dark:text-gray-400 max-w-3xl mx-auto mb-8 text-balance">
                              {t('start_for_free_description')}
                        </p>
                        <PricingTable onSubscribe={onSubscribe} />
                  </div>


            </SectionPageLayout>
      );
};

export default Pricing;
